




import { Component, Mixins, Prop } from "vue-property-decorator";
import { EditingDocument } from "..";
import { ApplicationDialogsAccessor } from "../CommonComponentsAccessor";
import { Dictionary } from "../../../../domain/system";
import { SignExecuteRequest, SignExecuteResult } from "../../../../domain/localhost/items";
import { SignItem } from "../../../../domain/document/items";

@Component
export default class SignAdapter extends Mixins() {
  @Prop()
  source: EditingDocument;

  @Prop()
  dialogs: ApplicationDialogsAccessor;

  async executeSign(item: SignItem): Promise<SignExecuteResult> {
    try {
      const result = await this.dialogs.launcher.show(null, this.editParameters, this.createSignExecuteRequest(item));
      this.$logger.debug(result);
      return result;
    } catch (e) {
      this.$error("サイン取得失敗", "サイン取得処理が完了できませんでした。", e);
      return null;
    }
  }

  private createSignExecuteRequest(item: SignItem): SignExecuteRequest {
    const request = new SignExecuteRequest();
    request.width = item.geometry.rectangle.width;
    request.height = item.geometry.rectangle.height;
    return request;
  }

  get editParameters(): Dictionary<string, string> {
    const dictionary = new Dictionary<string, string>();
    dictionary.set("action", "sign");
    return dictionary;
  }
}
